let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jg28y")).then(() => parcelRequire('3OvVE'));